export enum OverallOutcomeStatus {
  accepted = 'Accepted',
  rejected = 'Rejected',
  pass = 'Pass',
  fail = 'Fail',
  awaitingReview = 'Awaiting Review',
  awaitingResponse = 'Awaiting Response',
  awaiting = 'Awaiting',
  cancelled = 'Cancelled',
  passReview = 'PassReview',
  reOpened = 'Re-Opened',
}

export enum ReferenceOutcomeStatus {
  pending = 'Pending',
  pass = 'Pass',
  fail = 'Fail',
  expired = 'Expired',
  awaitingReview = 'AwaitingReview',
}

export enum OutcomeSectionName {
  identity = 'identity',
  credit = 'credit',
  income = 'income',
  residential = 'residential',
  organisation = 'organisation',
  financial = 'financial',
}

export enum OutcomeStatus {
  accepted = 'accepted',
  rejected = 'rejected',
  pass = 'pass',
  fail = 'fail',
  conditionsMet = 'conditions_met',
  conditionalPass = 'conditional_pass',
  reOpened = 're-Opened',
  awaitingReview = 'awaiting review',
  awaitingResponse = 'awaiting response',
}

export enum GraphQLOutcomeStatus {
  accepted = 'accepted',
  rejected = 'rejected',
  pass = 'pass',
  fail = 'fail',
  conditionsMet = 'conditions_met',
  conditionalPass = 'conditional_pass',
  reOpened = 're_opened',
  awaitingReview = 'awaiting_review',
  awaitingResponse = 'awaiting_response',
}

export enum IdentityOutcomePropertyName {
  photoId = 'photoId',
  nameMatch = 'nameMatch',
  dobMatch = 'dobMatch',
  facialMatch = 'facialMatch',
}

export type IdentityOutcomeProperty = {
  name: IdentityOutcomePropertyName
  status: OutcomeStatus
}

export type GraphQLIdentityOutcomeProperty = {
  name: IdentityOutcomePropertyName
  status: GraphQLOutcomeStatus
}

export type IdentityOutcome = {
  name: OutcomeSectionName.identity
  status: OutcomeStatus
  properties: IdentityOutcomeProperty[]
}

export enum CreditOutcomePropertyName {
  residencyConfirmations = 'residency confirmations',
  identityConfirmations = 'identity confirmations',
  risk = 'risk',
  adverseCredit = 'adverse credit',
}

export type CreditOutcomeProperty = {
  name: CreditOutcomePropertyName
  status: OutcomeStatus
}

export type GraphQLCreditOutcomeProperty = {
  name: CreditOutcomePropertyName
  status: GraphQLOutcomeStatus
}

export type CreditOutcome = {
  name: OutcomeSectionName.credit
  status: OutcomeStatus
  properties: CreditOutcomeProperty[]
}

export type IncomeOutcome = {
  name: OutcomeSectionName.income
  status: OutcomeStatus
}

export type FinanceOutcome = {
  name: OutcomeSectionName.financial
  status: OutcomeStatus
}

export enum ResidentialOutcomePropertyName {
  addressReference = 'address-reference',
}

export type ResidentialOutcomeProperty = {
  name: ResidentialOutcomePropertyName
  status: OutcomeStatus
}

export type GraphQLResidentialOutcomeProperty = {
  name: ResidentialOutcomePropertyName
  status: GraphQLOutcomeStatus
}

export type ResidentialOutcome = {
  name: OutcomeSectionName.residential
  status: OutcomeStatus
  properties: ResidentialOutcomeProperty[]
}

export type OrganisationOutcome = {
  name: OutcomeSectionName.organisation
  status: OutcomeStatus
}

export type OutcomeSection =
  | IdentityOutcome
  | CreditOutcome
  | IncomeOutcome
  | ResidentialOutcome
  | OrganisationOutcome
  | FinanceOutcome

export type Outcome = {
  status: OverallOutcomeStatus
  comments: string
  sections: OutcomeSection[] | null
}
